import React from "react";
import Link from "next/link";

import BoardPageTitle from "../BoardPageTitle";
import Styled from "./index.styles";

// categoryList 일 때 Depth는 Category > Board 순 입니다.
interface CategoryItem {
  boardList: BoardTitleItem[];
  boardTitle: React.ReactNode;
  boardHref: string;
}

interface CategoryListProps {
  type: "categoryList";
  categoryList: CategoryItem[];
}

interface BoardTitleItem {
  groupId: number;
  title: React.ReactNode;
}

interface BoardListProps {
  type: "boardList";
  boardList: BoardTitleItem[];
  boardHref: string;
}

export default function BoardCategory({
  title,
  currentContentsId,
  className,
  ...propsByType
}: {
  title: React.ReactNode;
  currentContentsId: number;
  className?: string;
} & (BoardListProps | CategoryListProps)) {
  return (
    <Styled.container
      className={`${className ? className : ""} board-category`}
    >
      <BoardPageTitle titleStyle="default">{title}</BoardPageTitle>

      {propsByType.type === "categoryList" && (
        <ol>
          {propsByType.categoryList.map(
            ({ boardTitle, boardList, boardHref }: CategoryItem, i) => (
              <li key={`category-${i}`}>
                <h4>
                  <Link href={boardHref}>
                    <a>{boardTitle} </a>
                  </Link>
                </h4>

                <ol>
                  {boardList.map(({ groupId, title }: BoardTitleItem) => (
                    <Styled.boardItemTitle
                      key={`board-item-${groupId}`}
                      isCurrentContents={currentContentsId === groupId}
                    >
                      <Link href={`${boardHref}/${groupId}`}>
                        <a>{title} </a>
                      </Link>
                    </Styled.boardItemTitle>
                  ))}
                </ol>
              </li>
            )
          )}
        </ol>
      )}

      {propsByType.type === "boardList" && (
        <ul>
          {propsByType.boardList.map(({ groupId, title }: BoardTitleItem) => (
            <Styled.boardItemTitle
              key={`board-item-${groupId}`}
              isCurrentContents={currentContentsId === groupId}
            >
              <Link href={`${propsByType.boardHref}/${groupId}`}>
                <a>{title}</a>
              </Link>
            </Styled.boardItemTitle>
          ))}
        </ul>
      )}
    </Styled.container>
  );
}
